<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :rules="rule" :label-width="120">
                <Row>
                    <Col span="12">
                        <FormItem  :label="$t('user_code')" prop="user_code">
                            <Input v-model="user_code" disabled></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem  :label="$t('user_cname')" prop="user_cname">
                            <Input v-model="user_cname" disabled></Input>
                            <input style="width: 0;height:0;border: 0;float: left" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="tree-box">
                <div v-for="item in listData" :key="item.org_id">
                    <span><Icon class="left-icon" type="ios-arrow-down" />{{item.org_cname}}</span>
                    <div class="role-box" v-show="item.roles.length > 0">
                        <Tag checkable :checked="role.checked=== '1'" color="success" v-for="(role,index) in item.roles" :key="index" :name="role.role_id" @on-change="tagChange">{{role.role_cname}}</Tag>
                    </div>
                    <div class="sub-tree c1" v-for="item2 in item.downs" :key="item2.org_id">
                        <span><Icon class="left-icon" type="ios-arrow-down" />{{item2.org_cname}}</span>
                        <div class="role-box" v-show="item2.roles.length > 0">
                            <Tag checkable :checked="role.checked=== '1'" color="success" v-for="(role,index) in item2.roles" :key="index" :name="role.role_id" @on-change="tagChange">{{role.role_cname}}</Tag>
                        </div>
                        <div class="sub-tree c2" v-for="item3 in item2.downs" :key="item3.org_id">
                            <span><Icon class="left-icon f-yellow" type="ios-ribbon" />{{item3.org_cname}}</span>
                            <div class="role-box" v-show="item3.roles.length > 0">
                                <Tag checkable :checked="role.checked=== '1'" color="success" v-for="(role,index) in item3.roles" :key="index" :name="role.role_id" @on-change="tagChange">{{role.role_cname}}</Tag>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
        </div>
    </div>
</template>

<script>
    export default {
        data:function(){
            return{
                relist:false,
                op: this.$base.getRequest().op,
                org_levels:[],
                formData: {
                    u_id: '',
                },
                cats: [],
                listData: [],
                user_cname : '',
                user_code: '',
                rule: {
                }
            }
        },
        computed:{
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.user_cname = this.$base.getRequest().user_cname;
            this.user_code = this.$base.getRequest().user_code;
            this.formData.u_id = this.$base.getRequest().u_id;
            this.getLoad();
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getLoad: function(){
                let url = ''
                if (this.$base.getOrgLevel() == '1') {
                    url = 'user-downrole-s1/list'
                } else if (this.$base.getOrgLevel() == '2') {
                    url = 'user-downrole-s2/list'
                }
                const u_id = this.formData.u_id;
                this.$base.showLoading();
                this.$request.sendPost(url,{u_id},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.listData = data.list
                    }
                    else{
                        this.$base.alertErr(this.$t('error'),error.errmsg);
                    }
                });
            },
            tagChange: function (checked, name) {
                let url = '';
                if (this.$base.getOrgLevel() == '1') {
                    url = checked ? 'user-downrole-s1/add' : 'user-downrole-s1/del'
                } else if (this.$base.getOrgLevel() == '2') {
                    url = checked ? 'user-downrole-s2/add' : 'user-downrole-s2/del'
                }
                const msg = checked ? '' : this.$t('delete_succeed');
                this.setRole(url, name, msg)
            },
            setRole: function (url, role_id, msg) {
                const u_id = this.formData.u_id;
                this.$base.showLoading();
                this.$request.sendPost(url,{u_id, role_id},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.msgSuccess(msg || error.errmsg);
                    }
                    else{
                        this.$base.alertErr(this.$t('error'),error.errmsg);
                    }
                });
            },
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>
    .role-box{
        border: dashed 1px #40AE2B;
        padding: 5px;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/pages/org/user/user_listdownrole.vue